import * as repassecomissao from '@/api/repassecomissao'

function popularIdsComerciais (payload) {
  payload.vendedor_id = payload.vendedor ? payload.vendedor.value : null
  payload.regional_id = payload.regional ? payload.regional.value : null
  payload.supervisor_id = payload.supervisor ? payload.supervisor.value : null
  return payload
}

const state = {
  modalPromotora: false,
  listValores: [],
  liberado: {
    valor: 0,
    quantidade: 0
  }
}

const mutations = {
  MODALPROMOTORA (state) {
    state.modalPromotora = !state.modalPromotora
  },
  SETTOTALIZADORES (state, payload) {
    state.listValores = payload
  },
  SETLIBERADO (state, payload) {
    state.liberado = {
      valor: payload.valor_total,
      quantidade: payload.quantidade
    }
  }
}

const actions = {
  async getComissoes ({ commit }, payload) {
    payload.mostrar_todos = false
    popularIdsComerciais(payload)
    let data = await repassecomissao.getComissoes(payload)
    return data.instancia
  },
  async getTodasComissoes ({ commit }, payload) {
    payload.mostrar_todos = true
    popularIdsComerciais(payload)
    let data = await repassecomissao.getComissoes(payload)
    return data.instancia
  },
  async getTodasComissoesRelatorioVendedor ({ commit }, payload) {
    let data = await repassecomissao.getComissoesRelatorioVendedor(payload)
    return data.instancia
  },
  modalPromotora: function ({ commit }) {
    commit('MODALPROMOTORA')
  },
  async getTotalizadores ({ commit }, payload) {
    let data = await repassecomissao.getTotalizadores(payload)
    commit('SETTOTALIZADORES', data.instancia)
  },
  async getLiberado ({ commit }, payload) {
    let data = await repassecomissao.getLiberado(payload)
    commit('SETLIBERADO', data.instancia)
  },
  async getTodosRepassesExportar ({ commit }, payload) {
    let result = await repassecomissao.getTodosRepassesExportar(payload)
    return result.instancia
  },
  acaoComissoes: async function ({ commit }, payload) {
    if (payload.acao === 'pagar') return repassecomissao.pagarComissoes(payload.comissoes)
    else if (payload.acao === 'baixar') return repassecomissao.baixarComissoes(payload.comissoes)
    else if (payload.acao === 'extornar') return repassecomissao.extornarComissoes(payload.comissoes)
    else throw new Error('Ação não permitida')
  },
  async getRelatorioComissoesAssinaturas ({ commit }, payload) {
    return repassecomissao.getRelatorioComissoesAssinaturas(payload)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/adm_financeiro/repassecomissao.js